// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__PSHUW","title":"InfoRow_title__16-n4"};